/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ExcelFormComponent as ɵc} from './excel-form/excel-form.component';
export {ExcelComponent as ɵb} from './excel.component';
export {declaration as ɵa} from './excel.module';
export {ExcelRoutes as ɵd} from './excel.routing';